module.exports = __webpack_public_path__ + "media/configurations/O-SX-7bac094d.png";